import { useState, useEffect, useContext } from 'react';
import ActionCardProps from '../interfaces/ActionCardProps';
import DeleteModal from './DeleteModal';
import EditModal from './EditModal';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dbActions from '../utils/db';
import MyReviewsContext from '../context/MyReviewsContext';
import Card from './Card';
import '../styles/Card.css';
import '../styles/ActionCard.css';

const ActionCard: React.FC<ActionCardProps> = ({ locationReview }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [confirmEdit, setConfirmEdit] = useState<boolean>(false);
  const { refreshReviews, setRefreshReviews } = useContext(MyReviewsContext);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    setShowEdit(true);
  };

  const handleDelete = () => {
    handleClose();
    setShowDelete(true);
  };

  useEffect(() => {
    const handleDeleteAction = async () => {
      try {
        if (confirmDelete) {
          const reviewDoc = (await dbActions.getReview(locationReview.locationId, locationReview.review.id!)).docRef;
          //check if locationId still has reviews
          const reviewCollection = await dbActions.getReviews(locationReview.locationId);
          dbActions.deleteDocument(reviewDoc);
          if (reviewCollection.length === 1) //if lenght is 1, the review that's about to be deleted is the only one, so the location needs to be deleted
          {
            const locationDoc = (await dbActions.getLocation(locationReview.locationId)).docRef;
            dbActions.deleteDocument(locationDoc);
          }
          setConfirmDelete(false);
          setRefreshReviews(!refreshReviews);
        }
      }
      catch {
        console.error("No se pudo borrar");
      }
    };

    handleDeleteAction();
  }, [confirmDelete])

  useEffect(() => {
    setRefreshReviews(!refreshReviews);
  }, [confirmEdit])

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setShowEdit(false);
        setShowDelete(false);
      }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  })

  return (
    <div className="card-with-menu">
      <Card 
        review={locationReview.review} 
        address={locationReview.address} 
        locationId={locationReview.locationId} 
        showTitle
      >
        {showDelete && <DeleteModal setConfirmDelete={setConfirmDelete} setShowDelete={setShowDelete}/>}
        {showEdit && 
          <EditModal 
            setShowEdit={setShowEdit} 
            locationId={locationReview.locationId} 
            reviewId={locationReview.review.id!} 
            setConfirmEdit={setConfirmEdit}
            confirmEdit={confirmEdit}
          />
        }
          <div className="action-card action-menu">
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleEdit}>Editar</MenuItem>
              <MenuItem onClick={handleDelete}>Borrar</MenuItem>
            </Menu>
          </div>
      </Card>  
    </div>
  );
};

export default ActionCard;
